import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import * as constants from "./constants";
import { actionTypes } from "./reducer";
import { isFeatureEnabled } from '../../util/helpers';

const MuteAction = (props) => {
  const dispatch = useDispatch();
  const MUTE_STATE = useSelector((state) => {
    return state.ticker[constants.CALL_COMMANDS.MUTE];
  });

  return (
    <>
      {props.callFlow.isSipCall() && (
        <div className="mute-call click-icon" style={{ minWidth: "50px" }}>
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              MUTE_STATE === constants.MUTE_STATES.NOT_ON_MUTE
                ? props.callFlow.callAction(
                    constants.CALL_COMMANDS.MUTE,
                    { value: constants.MUTE_STATES.ON_MUTE },
                    dispatch
                  )
                : props.callFlow.callAction(
                    constants.CALL_COMMANDS.MUTE,
                    { value: constants.MUTE_STATES.NOT_ON_MUTE },
                    dispatch
                  );
            }}
          >
            {MUTE_STATE !== constants.MUTE_STATES.ON_MUTE && (
              <img
                alt=""
                className="mute-call-icon"
                src={toAbsoluteUrl("/media/sr/icons/mute.svg")}
              />
            )}

            {MUTE_STATE === constants.MUTE_STATES.ON_MUTE && (
              <img
                alt=""
                className="mute-call-icon"
                src={toAbsoluteUrl("/media/sr/icons/mute-active.svg")}
              />
            )}
          </a>
        </div>
      )}
    </>
  );
};

const HoldAction = (props) => {
  const dispatch = useDispatch();

  const HOLD_STATE = useSelector((state) => {
    return state.ticker[constants.CALL_COMMANDS.HOLD];
  });

  return (
    <>
      <div className="pause-call click-icon" style={{ minWidth: "50px" }}>
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault();
            HOLD_STATE === constants.HOLD_STATES.ON_UNHOLD
              ? props.callFlow.callAction(
                  constants.CALL_COMMANDS.HOLD,
                  { value: constants.HOLD_STATES.ON_HOLD },
                  dispatch
                )
              : props.callFlow.callAction(
                  constants.CALL_COMMANDS.HOLD,
                  { value: constants.HOLD_STATES.ON_UNHOLD },
                  dispatch
                );
          }}
        >
          {HOLD_STATE === constants.HOLD_STATES.ON_HOLD && (
            <img
              alt=""
              className="pause-call-icon"
              src={toAbsoluteUrl("/media/sr/icons/pause-active.svg")}
            />
          )}
          {HOLD_STATE !== constants.HOLD_STATES.ON_HOLD && (
            <img
              alt=""
              className="pause-call-icon"
              src={toAbsoluteUrl("/media/sr/icons/pause.svg")}
            />
          )}
        </a>
      </div>
    </>
  );
};

const DialPadAction = (props) => {
  const dispatch = useDispatch();
  const DIALPAD_STATE = useSelector(state => {return state.ticker[constants.CALL_COMMANDS.DIALPAD];});

  const dispatchOpenDialpad = () => {
    if (DIALPAD_STATE == constants.DIALPAD_STATE.DIALPAD_CLOSED) {
      const payload = {}
      payload[constants.CALL_COMMANDS.DIALPAD] = constants.DIALPAD_STATE.DIALPAD_OPENED
      dispatch({ type: 'onCallStateChange', payload: payload })
    }
    dispatch({ type: actionTypes.onCallViewState, payload: { view_state: constants.CALL_VIEW_STATES.CALL_DIALPAD } })
  }

  return (
    <div className="pause-call click-icon" style={{ minWidth: '50px' }}>
      <a href="#"
        onClick={() => dispatchOpenDialpad()}>
        <img className="" style={{ height: 48, width: 48 }} src={toAbsoluteUrl("/media/sr/icons/dialpad/dialpad-icon.svg")} />
      </a>
    </div>
  );
  
}

export const CallControls = (props) => {
  const dispatch = useDispatch();
  const call_solution = useSelector(state => state.ticker.call_solution);

  return (
    <div className="call-ctrl row justify-content-center">
      {isFeatureEnabled('is_dialpad_enabled') && (call_solution == 'c2c' || call_solution == 'inbound_noncc') && props.callFlow.isSipCall() && <DialPadAction {...props}/>} 
      <HoldAction {...props} />
      <MuteAction {...props} />
      {props.callFlow.isSipCall() && (
        <div
          className="disconnect-call click-icon"
          style={{ minWidth: "50px" }}
        >
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              props.callFlow.callDisconnect(dispatch);
            }}
          >
            <img
              alt=""
              className="disconnect-call-icon"
              src={toAbsoluteUrl("/media/sr/icons/disconnect-call.svg")}
            />
          </a>
        </div>
      )}
    </div>
  );
};
